import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { serialize } from "../../helpers/Utils";

export const mixingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        getMixingLogs: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/mixing/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['mixingLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getMixingSummary: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/mixing/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['mixingSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createMixingLog: build.mutation({
            query: (requestBody) => ({
                url: `/pasting/mixing/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['mixingLogs', 'mixingSummary' ,'pastingOverview' ,'cartSummaryOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Mixing Log");
            },
        }),

        createWasteMaterial: build.mutation({
            query: (requestBody) => ({
                url: `/mixing-waste-material/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['mixingSummary', 'mixingWasteMaterial'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Waste Material");
            },
        }),

        getMixingWasteMaterial: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/get-mixing-waste-material?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['mixingWasteMaterial'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createMixingPending: build.mutation({
            query: (requestBody) => ({
                url: `/mixing-pending-create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['mixingSummary' ,'MixingPendingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Mixing Pending");
            },
        }),

        updateMixingLog: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/pasting/mixing/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['mixingLogs', 'mixingSummary' ,'pastingOverview','cartSummaryOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Mixing Log");
            },
        }),

        getPastingLogs: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getPastingPackingLog: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/get-pasting-packing-log?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingPackingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        updatePastingLog: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/pasting/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['pastingLogs','pastingPackingSummary' ,'pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Pasting Log");
            },
        }),

        createPastingLog: build.mutation({
            query: (requestBody) => ({
                url: `/pasting/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['pastingLogs','pastingPackingSummary','pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Pasting Log");
            },
        }),

        createPastingPacking: build.mutation({
            query: (requestBody) => ({
                url: `/pasting-packing/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['pastingLogs','pastingPackingSummary','pastingOverview','pastingPackingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Pasting Packing");
            },
        }),

        updatePastingPacking: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/pasting-packing/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['pastingLogs','pastingPackingSummary','pastingOverview','pastingPackingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Pasting Packing");
            },
        }),

        getPastingPackingSummary: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting-packing-summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingPackingSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        generatePastingBatchCode: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/generate-batch-code?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['generatePastingBatchCode'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),


        // ############## PASTING DASHBOARD API ###################
        getPastingOverview: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        //  ################ Mixing Pending Record API ################ 

        getMixingPending: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/get-mixing-pending-log?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['MixingPendingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        //  ################ Create Pasting Waste ##################

        createPastingPackingWaste: build.mutation({
            query: (requestBody) => ({
                url: `/packing-waste/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['getPackingWasteQuery','pastingPackingSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Packing Waste");
            },
        }),

        getPastingPackingWaste: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/get-packing-waste?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['getPackingWasteQuery'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),


        // ################## Packing Pending Log #############

        createPackingPending: build.mutation({
            query: (requestBody) => ({
                url: `/packing-pending-create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['pastingPackingSummary' ,'PackingPendingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Packing Pending");
            },
        }),

        getPackingPending: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/get-packing-pending-log?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['PackingPendingLog'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        
    }),
});

export const {
    useGetMixingLogsQuery,
    useGetMixingSummaryQuery,
    useCreateMixingLogMutation,
    useCreateWasteMaterialMutation,
    useGetMixingWasteMaterialQuery,
    useCreateMixingPendingMutation,
    useUpdateMixingLogMutation,
    useGetPastingLogsQuery,
    useGetPastingPackingLogQuery,
    useCreatePastingLogMutation,
    useCreatePastingPackingMutation,
    useUpdatePastingLogMutation,
    useUpdatePastingPackingMutation,
    useGetPastingPackingSummaryQuery,
    useGeneratePastingBatchCodeQuery,
    useGetPastingOverviewQuery ,
    useGetMixingPendingQuery ,
    useCreatePastingPackingWasteMutation,
    useGetPastingPackingWasteQuery,
    useCreatePackingPendingMutation,
    useGetPackingPendingQuery
} = mixingApi;
